import client from '../../client';

import type {
  IAiAgentAsCsListResponse,
  IAsCsFilesParams,
  IAsCsProcessHistoryParams,
  IAsUploadUrlParams,
  IGetAiAgentAsCsListParams,
} from './type';

export const aiAgentAsCsApis = {
  getAsUploadUrl: (data: IAsUploadUrlParams) => client.post(`/ai-agent/model/file-upload/as`, data),
  getAsCsList: (params: IGetAiAgentAsCsListParams) => client.get<IAiAgentAsCsListResponse>(`/ai-agent/as-cs`, { params }),
  getAsCsDetail: ({ id }: { id: number }) => client.get(`/ai-agent/as-cs/${id}`),
  getAsCsProcessHistory: ({ id, ...rest }: IAsCsProcessHistoryParams) =>
    client.get(`/ai-agent/as-cs/${id}/process`, { params: rest }),
  getAsCsProcessHistoryDetail: ({ id, processId }: { id: number; processId: number }) =>
    client.get(`/ai-agent/as-cs/${id}/process/${processId}`),
  getAsCsFiles: ({ companyId, ...rest }: IAsCsFilesParams) =>
    client.get(`/extension/model-upload/${companyId}`, { params: rest }),
};
